import {Grid, Paper as MuiPaper, Stack, styled, Table, TableCell as MuiTableCell, TableRow, Typography, useTheme} from "@mui/material";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import dayjs from "dayjs";
import useMediaQuery from "@mui/material/useMediaQuery";

const Paper = styled(MuiPaper)(({theme}) => ({
    background: theme.palette.contrastGrey.light,
}));

const TableCell = styled(MuiTableCell)(({theme}) => ({
    border: `1px solid ${theme.palette.contrastGrey.main}`,
    textAlign: "center",
    [theme.breakpoints.up('sm')]: {
        width: "120px",
    },
    background: '#fff',
}));

const HeadCell = styled(TableCell)(({theme}) => ({
    background: theme.palette.payAwards.light,
    [theme.breakpoints.down('sm')]: {
        textAlign: "right",
    },
}));

const TableCellContent = styled(Typography)(() => ({
    variant: 'body2',
    fontWeight: 'bold',
}));

const formatDate = (date) => {
    return dayjs(date).format('DD MMM YYYY');
};

const formatNumber = (value) => {
    return typeof value === 'number' ? `${value.toLocaleString(undefined, {minimumFractionDigits: 1})}%` : '';
};

const AwardsHeadline = ({data, label}) => {
    const theme = useTheme();
    const isSmallView = useMediaQuery(theme.breakpoints.up('sm'));

    if (!data) {
        return <>Loading...</>;
    }

    return (
        <Paper>
            <Grid container sx={{padding: {xs: '0.5rem', sm: '1rem'}}}>
                <Grid sx={{flexGrow: 1, overflow: "hidden", textOverflow: 'ellipsis', width: {xs: "250px", sm: "300px"}}}>
                    <Stack spacing={2} sx={{paddingBottom: '0.5rem'}}>
                        <Typography variant="h5" noWrap={isSmallView}>{label}</Typography>
                        <Typography variant="h6">{formatDate(data.fromEffectiveDate)} - {formatDate(data.toEffectiveDate)}</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    {isSmallView ? (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <HeadCell><TableCellContent>Number of pay awards</TableCellContent></HeadCell>
                                    <HeadCell><TableCellContent>Lower quartile</TableCellContent></HeadCell>
                                    <HeadCell><TableCellContent>Median</TableCellContent></HeadCell>
                                    <HeadCell><TableCellContent>Upper quartile</TableCellContent></HeadCell>
                                    <HeadCell><TableCellContent>Average</TableCellContent></HeadCell>
                                    <HeadCell><TableCellContent>Weighted average</TableCellContent></HeadCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell><TableCellContent>{data.total}</TableCellContent></TableCell>
                                    <TableCell><TableCellContent>{formatNumber(data.lowerQuartile)}</TableCellContent></TableCell>
                                    <TableCell><TableCellContent>{formatNumber(data.medianQuartile)}</TableCellContent></TableCell>
                                    <TableCell><TableCellContent>{formatNumber(data.upperQuartile)}</TableCellContent></TableCell>
                                    <TableCell><TableCellContent>{formatNumber(data.average)}</TableCellContent></TableCell>
                                    <TableCell><TableCellContent>{formatNumber(data.weightedAverage)}</TableCellContent></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    ) : (
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <HeadCell><TableCellContent>Number of pay awards</TableCellContent></HeadCell>
                                    <TableCell><TableCellContent>{data.total}</TableCellContent></TableCell>
                                </TableRow>
                                <TableRow>
                                    <HeadCell><TableCellContent>Lower quartile</TableCellContent></HeadCell>
                                    <TableCell><TableCellContent>{formatNumber(data.lowerQuartile)}</TableCellContent></TableCell>
                                </TableRow>
                                <TableRow>
                                    <HeadCell><TableCellContent>Median</TableCellContent></HeadCell>
                                    <TableCell><TableCellContent>{formatNumber(data.medianQuartile)}</TableCellContent></TableCell>
                                </TableRow>
                                <TableRow>
                                    <HeadCell><TableCellContent>Upper quartile</TableCellContent></HeadCell>
                                    <TableCell><TableCellContent>{formatNumber(data.upperQuartile)}</TableCellContent></TableCell>
                                </TableRow>
                                <TableRow>
                                    <HeadCell><TableCellContent>Average</TableCellContent></HeadCell>
                                    <TableCell><TableCellContent>{formatNumber(data.average)}</TableCellContent></TableCell>
                                </TableRow>
                                <TableRow>
                                    <HeadCell><TableCellContent>Weighted average</TableCellContent></HeadCell>
                                    <TableCell><TableCellContent>{formatNumber(data.weightedAverage)}</TableCellContent></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    )}
                </Grid>
            </Grid>
        </Paper>
    );
};

export default AwardsHeadline;
